import React from "react";
import Spinner from "../elements/Spinner/Spinner";

export function withLoadingSpinner(WrappedComponent) {
  return class extends React.Component {
    render() {
      if (this.props.data && this.props.data.loading) {
        return <Spinner />;
      } else {
        return <WrappedComponent {...this.props} />;
      }
    }
  };
}

export function withLoadingWait(WrappedComponent) {
  return class extends React.Component {
    render() {
      // console.log("withLoadingWait", this.props.data);
      if (this.props.data && this.props.data.loading) {
        return null;
      } else {
        return <WrappedComponent {...this.props} />;
      }
    }
  };
}
